import React, { useEffect, useState, setGlobal } from "reactn";
import PropTypes from "prop-types";

// hooks
import appHook from "../../../hooks/appHook";

// components
import Input from "shared-anpost-components/components/form/input/Input";
import Select from "shared-anpost-components/components/form/select/Select";
import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Label from "shared-anpost-components/components/form/label/Label";
import FieldError from "shared-anpost-components/components/form/fieldError/FieldError";

// config
import { setMobileFieldRestrictions, getCountryData } from "./Mobile.helpers";

// helpers
import { allowOnlyNumbers } from "../../../helpers/Helpers";

const MobilePhone = ({ id, handleChange, handleKeyup, handleBlur, values, errors, lockCountryCode }) => {
    // hooks
    const { handleFocus, focus } = appHook();
    const [mobileMax, setMobileMax] = useState("10");
    const [prefixMax, setPrefixMax] = useState("5");

    // element Ids
    const countryCodeId = `${id}CountryCode`;
    const prefixId = `${id}Prefix`;
    const numberId = `${id}Number`;

    const removeLeadingZeros = number => {
        return number.replace(/^0+/, "");
    };

    // set field restrictions on the the fields depending on whether it is IE or UK
    const setFieldRestrictions = () => {
        if (values[countryCodeId]) {
            // get the max lengths for the prefix and the mobile number fields
            const mobileRestrictions = setMobileFieldRestrictions(values[countryCodeId], values[prefixId]);
            setMobileMax(mobileRestrictions.mobileMaxLength);
            setPrefixMax(mobileRestrictions.prefixMaxLength);
        }
    };

    useEffect(() => {
        setFieldRestrictions();
    }, []);

    useEffect(() => {
        const tempValues = values;
        if (values[countryCodeId] && values[prefixId] && values[numberId]) {
            // get the country code
            const countryCode = values[countryCodeId].substr(values[countryCodeId].indexOf("-") + 1, values[countryCodeId].length);

            // set the global value of the the country code, prefix and number concatanated together
            tempValues[id] = `+${countryCode}${removeLeadingZeros(values[prefixId])}${values[numberId]}`;
        } else {
            // clear the global value of this phone number if any of thses do not exist: country code, prefix or number
            tempValues[id] = "";
        }

        // reset global values object
        setGlobal({ values: tempValues });

        setFieldRestrictions();
    }, [values]);
    return (
        <FormGroup classes="form__mobile-fields">
            <FormGroup error={errors[countryCodeId]}>
                <Select
                    id={countryCodeId}
                    type="text"
                    name={countryCodeId}
                    change={handleChange}
                    keyup={handleKeyup}
                    focused={focus === countryCodeId ? true : !!(false || values[countryCodeId])}
                    focus={handleFocus}
                    blur={handleBlur}
                    labelText="Country"
                    options={getCountryData()}
                    selectedValue={values[countryCodeId] || ""}
                    required
                    disabled={lockCountryCode}
					ariaDescribedby={`${countryCodeId}Error`}
                />
                {errors[countryCodeId] && <FieldError error={errors[countryCodeId]} id={`${countryCodeId}Error`} />}
            </FormGroup>
            <FormGroup focused={focus === prefixId ? true : !!(false || values[prefixId])} error={errors[prefixId]}>
                <InputGroup>
                    <Label htmlFor={prefixId} text="Prefix" />
                    <Input
                        id={prefixId}
                        type="text"
                        name={prefixId}
                        change={handleChange}
                        keypress={allowOnlyNumbers}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[prefixId] || ""}
                        required
                        maxLength={prefixMax}
                        showNumberKeypad
						ariaDescribedby={`${prefixId}Error`}
                    />
                </InputGroup>
                {errors[prefixId] && <FieldError error={errors[prefixId]} id={`${prefixId}Error`}/>}
            </FormGroup>
            <FormGroup focused={focus === numberId ? true : !!(false || values[numberId])} error={errors[numberId]}>
                <InputGroup>
                    <Label htmlFor={numberId} text="Mobile" />
                    <Input
                        id={numberId}
                        type="text"
                        name={numberId}
                        change={handleChange}
                        keyup={handleKeyup}
                        keypress={allowOnlyNumbers}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[numberId] || ""}
                        required
                        maxLength={mobileMax}
                        showNumberKeypad
						ariaDescribedby={`${numberId}Error`}
                    />
                </InputGroup>
                {errors[numberId] && <FieldError error={errors[numberId]} id={`${numberId}Error`} />}
            </FormGroup>
        </FormGroup>
    );
};

MobilePhone.propTypes = {
    id: PropTypes.string,
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    lockCountryCode: PropTypes.bool
};

export default MobilePhone;
